<template lang='slm'>
  svg.circle @click='$emit("click", $event)' :class='[{ playing, loading }, "progress-"+intProgress]' viewBox='0 0 80 80' :width='circleSize * scale + "px"' :height='circleSize * scale + "px"'
    circle.bg v-if='drawBg' cx='50%' cy='50%' fill='white'
    circle.circle cx='50%' cy='50%' fill='none' :stroke='color'
    g.play-pause :fill='color'
      path.pause d="M 0 0 l 0 26 8.6 0 0 -26 -8.6 0 M 17.3 0 l 0 26 8.6 0 0 -26 -8.6 0"
      path.play d="M 5 0 l 0 26 22.52 -13 -22.52 -13"
</template>

<style lang='stylus' scoped>
  circle_size = 80px
  stroke_width = 8px
  radius = circle_size / 2 - stroke_width / 2
  circle_length = 2 * 3.14 * radius
  play_pause_size = 26px

  @keyframes loading
    0%
      stroke-dasharray 0 0 0 circle_length 0 0 0 0
    33.3%
      stroke-dasharray 0 0 (circle_length / 4) (circle_length / 2) (circle_length / 4) 0 0 0
    66.6%
      stroke-dasharray 0 (circle_length / 4) (circle_length / 4) 0 (circle_length / 4) 0 0 (circle_length / 4)
    100%
      stroke-dasharray 0 (circle_length / 2) 0 0 0 0 0 (circle_length / 2)

  .circle
    // width circle_size
    // height circle_size
    -webkit-tap-highlight-color transparent
    .bg
      r (radius + stroke_width / 2)
    .circle
      r radius
      stroke-width 0
      stroke-dashoffset (-3 * circle_length / 4)
      transition stroke-dasharray 0.1s linear
    .play-pause
      transform translate((circle_size - play_pause_size) / 2, (circle_size - play_pause_size) / 2)
      .play
      .pause
        transform-origin (play_pause_size / 2) (play_pause_size / 2)
        transition opacity 0.1s linear, transform 0.1s linear
      .play
        opacity 1
        transform rotate(0deg)
      .pause
        opacity 0
        transform rotate(-90deg)
    &.playing
      .play
        opacity 0
        transform rotate(90deg)
      .pause
        opacity 1
        transform rotate(0deg)
    &.loading
      .play
        opacity 0
        transform rotate(90deg)
      .circle
        r radius
        stroke-width stroke_width
        animation loading 1s infinite linear
    &:not(.loading)
      for i in (1..100)
        &.progress-{i}
          .circle
            stroke-width stroke_width
            stroke-dasharray (i * circle_length / 100) ((100 - i) * circle_length / 100)
</style>

<script>
export default {
  name: 'PlayPauseCircle',
  props: {
    scale: {
      type: Number,
      default: 1,
    },
    playing: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    progress: {
      // persent
      type: Number,
      default: 0,
    },
    drawBg: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: '#464646', // dark-color
    },
  },
  data() {
    return {
      circleSize: 80, // from css
    };
  },
  computed: {
    intProgress() {
      return Math.ceil(this.progress);
    },
  },
};
</script>
